var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "footer px-4 mx-2" }, [
    _c(
      "div",
      { staticClass: "row align-items-center justify-content-lg-between" },
      [
        _c("div", { staticClass: "col-lg-6" }, [
          _c(
            "div",
            { staticClass: "copyright text-center text-lg-left text-muted" },
            [
              _vm._v("\n        © " + _vm._s(_vm.year) + " "),
              _c(
                "a",
                {
                  staticClass: "font-weight-bold ml-1",
                  attrs: {
                    href: "https://www.creative-tim.com",
                    target: "_blank",
                  },
                },
                [_vm._v("Creative Tim")]
              ),
              _vm._v(" &\n        "),
              _c(
                "a",
                {
                  staticClass: "font-weight-bold ml-1",
                  attrs: {
                    href: "https://www.binarcode.com?ref=creative-tim",
                    target: "_blank",
                  },
                },
                [_vm._v("Binar Code")]
              ),
            ]
          ),
        ]),
        _vm._m(0),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "ul",
        {
          staticClass:
            "nav nav-footer justify-content-center justify-content-lg-end",
        },
        [
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                attrs: {
                  href: "https://www.creative-tim.com",
                  target: "_blank",
                },
              },
              [_vm._v("Creative Tim")]
            ),
          ]),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                attrs: {
                  href: "https://www.creative-tim.com/presentation",
                  target: "_blank",
                },
              },
              [_vm._v("About Us")]
            ),
          ]),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                attrs: {
                  href: "http://blog.creative-tim.com",
                  target: "_blank",
                },
              },
              [_vm._v("Blog")]
            ),
          ]),
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                attrs: {
                  href: "https://www.creative-tim.com/license",
                  target: "_blank",
                },
              },
              [_vm._v("License")]
            ),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }